<template>
  <page>
    <!-- <template slot="header"> 
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6">
            <h3 class="m-0 text-dark">
              Ordens de Serviço Preventivas
            </h3>
          </div>
          <div class="col-sm-6">
            <b-breadcrumb
              class="float-sm-right"
              :items="breadcrumbItems"
            ></b-breadcrumb>
          </div>
        </div>
      </div>
    </template> -->

    <template slot='content'>
      <indicadores-resumo-preventiva></indicadores-resumo-preventiva>

      <Hr />

      <os-preventiva></os-preventiva>

      <reloadPage></reloadPage>
    </template>
  </page>
</template>

<script>
import Page from '@/components/Page'
import OsPreventiva from '@/components/OsPreventiva'
import IndicadoresResumoPreventiva from '@/components/IndicadoresResumoPreventiva'

import reloadPage from '../common/reloadPage.vue'

export default {
  components: {
    Page,
    OsPreventiva,
    IndicadoresResumoPreventiva,
    reloadPage
  },

  computed:{
    mecanico() {
      let mecanicoOs = JSON.parse(localStorage.filial);
      if (mecanicoOs.atendeOs == 'S') {
        return false
      } else {
        return true
      }
    }
  },

  data () {
    return {
      isSidebarOpen: false,
      breadcrumbItems: [
        {
          text: 'Ordens de Serviço',
          active: true
        }
      ]
    }
  }
}
</script>
